import { signOutService } from '../Services/AuthenticationServices.js';

const SaveTokenInterceptor = (axiosInstance) => {
    axiosInstance.interceptors.response.use(
        (response) => {
            return response;
        },
        async (error) => {
            if (error?.response?.status === 401) {
                await signOutService();
                window.location.replace("/signin");
            }
            return Promise.reject(error);
        }
    );
};

export default SaveTokenInterceptor;
